<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Permits</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link href="./assets/libs/owl.carousel/assets/owl.carousel.min.css" rel="stylesheet">
    <link href="./assets/libs/owl.carousel/assets/owl.theme.default.min.css" rel="stylesheet">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Business Permits - Approved Permits</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Business Permits</a></li>
                    <li class="breadcrumb-item active">Approved Permits</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Approved</p>
                      <h4 class="mb-0 counter">{{ totalItems || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-check-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Revenue</p>
                      <h4 class="mb-0 counter">KES {{ numberFormat(totalAmount) }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-dollar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Selected for Sending</p>
                      <h4 class="mb-0 counter">{{ selectedCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-warning bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-send font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Today's Approvals</p>
                      <h4 class="mb-0 counter">{{ todayCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-info bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-calendar-check font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ToolBar/>

          <div class="row">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3" role="toolbar">
                    <label class="text-nowrap mb-0 px-2">Date From:</label>
                    <input v-model="dateFrom" class="form-control pr-3" type="date">
                    <label class="text-nowrap mb-0 px-2">Date To:</label>
                    <input v-model="dateTo" class="form-control pr-2" type="date">
                    <label class="text-nowrap mb-0 px-2">Business Activity:</label>
                    <select @change="getTradeSubCategory($event)" class="form-control bg-white" data-live-search="true" title="Select Business Activity">
                      <option value=" ">All</option>
                      <option :key="index" :value="item.incomeTypeId" v-for="(item, index) in tradeCategories">
                        {{ item.incomeTypeDescription }}
                      </option>
                    </select>
                    <label class="text-nowrap mb-0 mx-2">Business Sub Category:</label>
                    <select @change="selectedTradeSubCategory($event)" class="form-control bg-white" data-live-search="true" title="Select Sub Categories">
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in tradeSubCategories">
                        {{ item.feeDescription }}
                      </option>
                    </select>
                    <select @change="selectedSubCounty($event)" class="form-control bg-white mx-2" data-live-search="true" title="Select Sub County">
                      <option value="">All Sub Counties</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                        {{ item.subCountyName }}
                      </option>
                    </select>
                    <select @change="selectedWard($event)" class="form-control bg-white" data-live-search="true" title="Select Ward">
                      <option value="">All Wards</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                        {{ item.wardName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 align-items-center animated" role="toolbar">
                    <button @click="initiateSendPermits()" type="button" class="btn btn-success waves-effect btn-label waves-light me-3 text-uppercase btn-rounded shadow-sm" :disabled="selectedCount === 0 || isSending">
                      <i class="bx bx-paper-plane label-icon me-2"></i>
                      <span v-if="!isSending">Send Permits ({{ selectedCount }})</span>
                      <span v-else>
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        Processing...
                      </span>
                    </button>
                    <span v-if="selectedCount === 0" class="text-muted ms-3">
                      <i class="bx bx-info-circle me-1"></i>
                      Select at least one permit to send
                    </span>
                  </div>
                </div>

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3 flex-grow-1" role="toolbar">
                    <form class="app-search p-0 m-0 w-100">
                      <div class="position-relative">
                        <input v-model="search" type="text" class="form-control w-100" placeholder="Search... eg Business Name, ID Number, Bill Number, etc">
                        <span class="bx bx-search-alt"></span>
                      </div>
                    </form>
                  </div>
                  <div class="pr-3">
                    <button v-if="getRight('DOWNLOAD APPROVED SBP PERMITS')" @click="downloadApplicationsPaginated()" class="btn btn-primary btn-rounded shadow-sm" :disabled="isDownloading">
                      <i class="bx bx-download me-2"></i>
                      {{ isDownloading ? 'Downloading...' : 'Download' }}
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">
                          <input class="form-check-input mt-0 pt-0 form-check-dark" type="checkbox" id="selectAll" @change="toggleSelectAll" :checked="allSelected">
                          <label for="selectAll" class="d-non mx-3 mb-0">Receipt No.</label>
                        </th>
                        <th scope="col">Business ID</th>
                        <th scope="col">Business Name</th>
                        <th scope="col">Application Date</th>
                        <th>Licensing Officer</th>
                        <th>Status</th>
                        <th class="text-right" scope="col">Amount Paid</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" v-for="(item, index) in businesses" class="animated-row">
                        <td class="text-capitalize text-nowrap">
                          <input class="form-check-input mt-0 pt-0 form-check-dark me-2" type="checkbox" v-model="item.selected">
                          <a href="javascript: void(0);">{{item.billNo}}</a>
                        </td>
                        <td class="text-capitalize text-nowrap">{{item.businessID}}</td>
                        <td class="text-capitalize text-nowrap">
                          <a href="javascript: void(0);" class="text-primary fw-medium">{{item.businessName}}</a><br/>
                          <small class="text-muted">
                            {{maskPhoneNumber(item.ownerPhone)}} | {{item.ownerEmail}}
                          </small>
                        </td>
                        <td class="text-capitalize text-nowrap">{{formattedDate(item.startDate)}}</td>
                        <td>{{item.issuingOfficer || 'N/A'}}</td>
                        <td>
                          <span class="badge badge-soft-success text-uppercase rounded-pill">{{item.stageStatus}}</span>
                        </td>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(item.receiptAmount)}}</span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end">
                            <button @click="getBusinessDetails(item.businessID, item.billNo, item.feeID)" class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-2 btn-rounded" type="button">
                              <i class="bx bx-show font-size-16 align-middle me-2"></i>
                              Details
                            </button>
                            <a v-if="getRight('SBP PRINT PERMIT')" @click="printTradePermitBillNo(item.billNo, 'trade')" class="btn btn-success btn-sm waves-effect waves-light me-2 btn-rounded" href="javascript: void(0);">
                              <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                              View Permit
                            </a>
                            <div class="dropdown">
                              <a aria-haspopup="true" class="text-muted font-size-16" data-bs-toggle="dropdown" role="button">
                                <i class="bx bx-dots-vertical-rounded"></i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a @click="getBusinessDetails(item.businessID, item.billNo, item.feeID)" class="dropdown-item" href="javascript: void(0);">
                                  <i class="font-size-15 mdi mdi-eye me-3"></i>View
                                </a>
                                <a @click="printBill(item.billNo)" class="dropdown-item" href="javascript: void(0);">
                                  <i class="font-size-15 mdi mdi-printer me-3"></i>Print Bill
                                </a>
                                <a v-if="getRight('SBP EDIT BUSINESS DETAILS')" @click="openEditModal(item.businessID, item.billNo, item.feeID)" class="dropdown-item" href="javascript: void(0);">
                                  <i class="font-size-15 mdi mdi-file-document-edit me-3"></i>Edit Business
                                </a>
                                <a v-if="getRight('SBP TOP UP BUSINESS')" @click="openTopUpModal(item.businessID, item.billNo, item.feeID)" class="dropdown-item" href="javascript: void(0);">
                                  <i class="font-size-15 bx bxs-upvote me-3"></i>Top Up
                                </a>
                                <a v-if="getRight('SBP FIX BUSINESS ID')" @click="showFixBusinessIDModal(item.businessID, item.billNo)" class="dropdown-item" href="javascript: void(0);">
                                  <i class="font-size-15 bx bx-link-alt me-3"></i>Fix Same Business ID
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th>{{businesses.length}} Permits</th>
                        <th class="text-nowrap" colspan="5"></th>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(totalAmount)}}</span>
                        </td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center" v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <p>We are fetching the data for you. Please wait...</p>
                    </div>

                    <div class="card-body d-flex flex-column justify-items-center align-items-center text-center" v-if="businesses.length<1 && loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results" class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria.</p>
                    </div>
                  </div>
                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="pr-3 pb-0 mb-0 font-13px">Rows Per Page</span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="200">200 Rows</option>
                      </select>
                    </div>
                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a @click="prevPage" class="page-link">Previous</a>
                      </li>
                      <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" :class="{ active: currentPage === page }" class="page-item">
                        <span v-if="page === '...'" class="page-link">{{ page }}</span>
                        <a v-else @click="goToPage(page)" class="page-link">{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a @click="nextPage" class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Business Details Modal -->
      <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-full modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Business Details</h5>
              <span class="badge rounded-pill bg-success text-uppercase font-12px mx-3">{{entries.stageStatus}}</span>
              <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
            </div>
            <div class="modal-body">
              <div v-if="loadingDetails" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-3">Loading business details...</p>
              </div>

              <div v-else class="row">
                <div class="col-12">
                  <div class="hori-timeline mt-4">
                    <div class="owl-carousel owl-theme navs-carousel events timeline-carousel" id="timeline-carousel">
                      <div v-for="(item, index) in statuses" :key="index" :class="item.completed === 'active' ? 'active' : ''" class="item event-list" style="display: inline-block; width: 350px">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">{{getHumanDate(item.updatedDate)}}</div>
                            <h5 class="mb-4">{{item.status}}</h5>
                          </div>
                          <div class="event-down-icon">
                            <i v-if="item.completed === 'true'" class="bx bxs-check-circle h1 text-success down-arrow-icon"></i>
                            <i v-if="item.completed === 'false' || item.completed === 'active'" class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>
                          <div class="mt-3 px-3">
                            <p class="text-muted text-capitalize">{{item.issuingOfficer}}</p>
                            <p v-if="item.statusID !== '2'" class="text-muted text-capitalize mb-1">
                              <i class="bx bx-map"></i>{{item.location}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4 mt-4">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-info bg-soft">
                      <h6 class="mb-0">
                        <i class="bx bx-briefcase-alt-2 me-2"></i>Business Details
                      </h6>
                    </div>
                    <div class="card-body">
                      <dl class="row mb-0">
                        <dt class="col-5">Business Name:</dt>
                        <dd class="col-7">{{businessDetails.businessName || 'N/A'}}</dd>
                        <dt class="col-5">Business ID:</dt>
                        <dd class="col-7">{{businessDetails.businessID || 'N/A'}}</dd>
                        <dt class="col-5">Plot Number:</dt>
                        <dd class="col-7">{{businessDetails.plotNumber || 'N/A'}}</dd>
                        <dt class="col-5">KRA PIN:</dt>
                        <dd class="col-7">{{businessDetails.kraPin || 'N/A'}}</dd>
                        <dt class="col-5">Business Activity:</dt>
                        <dd class="col-7">{{businessDetails.businessDes || 'N/A'}}</dd>
                        <dt class="col-5">Category:</dt>
                        <dd class="col-7">{{businessDetails.businessCategory || 'N/A'}}</dd>
                        <dt class="col-5">Sub Category:</dt>
                        <dd class="col-7">{{businessDetails.businessSubCategory || 'N/A'}}</dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4 mt-4">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-warning bg-soft">
                      <h6 class="mb-0">
                        <i class="bx bxs-user-pin me-2"></i>Owner Details
                      </h6>
                    </div>
                    <div class="card-body">
                      <dl class="row mb-0">
                        <dt class="col-5">Full Names:</dt>
                        <dd class="col-7">{{businessDetails.fullNames || 'N/A'}}</dd>
                        <dt class="col-5">ID/PPT No:</dt>
                        <dd class="col-7">{{businessDetails.ownerID || 'N/A'}}</dd>
                        <dt class="col-5">Email:</dt>
                        <dd class="col-7">{{businessDetails.ownerEmail || 'N/A'}}</dd>
                        <dt class="col-5">Phone:</dt>
                        <dd class="col-7">{{maskPhoneNumber(businessDetails.ownerPhone) || 'N/A'}}</dd>
                        <dt class="col-5">Postal Address:</dt>
                        <dd class="col-7">{{businessDetails.postalAddress || 'N/A'}}</dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4 mt-4">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-danger bg-soft">
                      <h6 class="mb-0">
                        <i class="bx bx-phone-call me-2"></i>Location & Contact
                      </h6>
                    </div>
                    <div class="card-body">
                      <dl class="row mb-0">
                        <dt class="col-5">Business Phone:</dt>
                        <dd class="col-7">{{maskPhoneNumber(businessDetails.businessPhone) || 'N/A'}}</dd>
                        <dt class="col-5">Business Email:</dt>
                        <dd class="col-7">{{businessDetails.businessEmail || 'N/A'}}</dd>
                        <dt class="col-5">Sub County:</dt>
                        <dd class="col-7">{{businessDetails.subCountyName || 'N/A'}}</dd>
                        <dt class="col-5">Ward:</dt>
                        <dd class="col-7">{{businessDetails.wardName || 'N/A'}}</dd>
                        <dt class="col-5">Physical Address:</dt>
                        <dd class="col-7">{{businessDetails.physicalAddress || 'N/A'}}</dd>
                        <dt class="col-5">Building:</dt>
                        <dd class="col-7">{{businessDetails.buildingName || 'N/A'}}</dd>
                        <dt class="col-5">Room/Stall:</dt>
                        <dd class="col-7">{{businessDetails.roomNo || 'N/A'}}</dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <div v-if="businessDetails.lat && businessDetails.lng" class="col-12 mt-4">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-dark bg-soft">
                      <h6 class="mb-0">
                        <i class="bx bx-map me-2"></i>Map View
                      </h6>
                    </div>
                    <div class="card-body">
                      <iframe frameborder="0" scrolling="no" style="width: 100%; height: 400px; border-radius: 8px;" :src="`https://maps.google.com/maps?q=${businessDetails.lat},${businessDetails.lng}&t=&z=15&ie=UTF8&iwloc=&output=embed`"></iframe>
                    </div>
                  </div>
                </div>

                <div class="col-12 mt-4">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-primary bg-soft">
                      <h6 class="mb-0">
                        <i class="bx bx-receipt me-2"></i>Payment Information
                      </h6>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <h6 class="text-muted">Bill Details</h6>
                          <dl class="row">
                            <dt class="col-6">Bill No:</dt>
                            <dd class="col-6">{{billDetail.billNo || 'N/A'}}</dd>
                            <dt class="col-6">Amount:</dt>
                            <dd class="col-6">KES {{numberFormat(billDetail.detailAmount) || 0}}</dd>
                            <dt class="col-6">Paid:</dt>
                            <dd class="col-6">KES {{numberFormat(billDetail.receiptAmount) || 0}}</dd>
                            <dt class="col-6">Balance:</dt>
                            <dd class="col-6">KES {{numberFormat(billDetail.billBalance) || 0}}</dd>
                          </dl>
                        </div>
                        <div class="col-md-6">
                          <h6 class="text-muted">Receipt Details</h6>
                          <dl class="row">
                            <dt class="col-6">Receipt No:</dt>
                            <dd class="col-6">{{receiptDetails.receiptNo || 'N/A'}}</dd>
                            <dt class="col-6">Payment Date:</dt>
                            <dd class="col-6">{{formattedDate(receiptDetails.dateCreated) || 'N/A'}}</dd>
                            <dt class="col-6">Status:</dt>
                            <dd class="col-6">
                              <span class="badge bg-success">{{entries.status || 'Paid'}}</span>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <a v-if="getRight('SBP PRINT PERMIT')" @click="printTradePermit(businessDetails.businessID)" class="btn btn-primary waves-effect waves-light" href="javascript: void(0);">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> View Permit
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- OTP Modal -->
      <div class="modal fade" id="otpModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content border-0 shadow">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="bx bx-shield-quarter me-2"></i>
                Security Verification Required
              </h5>
              <button type="button" class="btn-close btn-close-white" @click="cancelOtpModal" :disabled="isVerifying" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="!invoicesSentSuccess">
                <div class="alert alert-info border-0 shadow-sm" role="alert">
                  <h5 class="alert-heading text-dark">
                    <i class="bx bx-lock-alt me-2"></i>OTP Verification
                  </h5>
                  <hr>
                  <p class="mb-2">
                    An OTP has been sent to your registered phone:
                    <strong>{{maskPhoneNumber(sessionPhoneNumber)}}</strong>
                  </p>
                  <p class="mb-0">
                    <strong>{{ selectedCount }} permit(s)</strong> will be sent to business owners
                    via SMS and Email after verification.
                  </p>
                </div>

                <div class="mt-4">
                  <label class="form-label fw-bold">
                    Enter OTP Code <span class="text-danger">*</span>
                  </label>
                  <div class="input-group input-group-lg">
                    <span class="input-group-text bg-light">
                      <i class="bx bx-key"></i>
                    </span>
                    <input v-model="otpCodes" class="form-control text-center font-monospace" :class="{ 'is-invalid': showOtpError }" type="text" placeholder="Enter 4-digit OTP" maxlength="4" pattern="[0-9]{4}" :disabled="isVerifying">
                    <button @click="resendOTP" type="button" class="btn btn-warning" :disabled="loadingOTP || isVerifying">
                      <span v-if="!loadingOTP">
                        <i class="bx bx-refresh me-1"></i>Resend
                      </span>
                      <span v-else>
                        <span class="spinner-border spinner-border-sm"></span>
                      </span>
                    </button>
                  </div>
                  <div v-if="showOtpError" class="invalid-feedback d-block">
                    <i class="bx bx-error-circle me-1"></i>
                    {{ otpErrorMessage }}
                  </div>
                  <div v-if="otpTimer > 0" class="text-muted small mt-2">
                    <i class="bx bx-time me-1"></i>
                    OTP expires in {{ otpTimer }} seconds
                  </div>
                </div>

                <div v-if="message" class="alert alert-danger mt-3" role="alert">
                  <i class="bx bx-error me-2"></i>{{ message }}
                </div>
              </div>

              <div v-if="invoicesSentSuccess" class="text-center py-4">
                <div class="mb-4">
                  <i class="bx bx-check-circle text-success animate-success" style="font-size: 72px;"></i>
                </div>
                <h4 class="text-success mb-3">Permits Sent Successfully!</h4>
                <p class="text-muted">
                  <strong>{{ selectedCount }} permit(s)</strong> have been successfully sent to the
                  selected business owners via SMS and Email.
                </p>
                <div class="alert alert-success mt-3">
                  <i class="bx bx-info-circle me-2"></i>
                  Notification delivery may take a few minutes to complete.
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button v-if="!invoicesSentSuccess" type="button" class="btn btn-secondary" @click="cancelOtpModal" :disabled="isVerifying">
                Cancel
              </button>
              <button v-if="!invoicesSentSuccess" @click="verifyOTP" class="btn btn-success" :disabled="!otpCodes || otpCodes.length !== 4 || isVerifying">
                <span v-if="!isVerifying">
                  <i class="bx bx-check me-2"></i>Verify & Send
                </span>
                <span v-else>
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Verifying...
                </span>
              </button>
              <button v-if="invoicesSentSuccess" type="button" class="btn btn-primary" @click="closeOtpModal">
                <i class="bx bx-check me-2"></i>Done
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Business Modal Component -->
      <EditBusinessModal
          ref="editBusinessModal"
          :business-i-d="selectedBusinessID"
          :bill-no="selectedBillNo"
          :fee-i-d="selectedFeeID"
          @success="handleEditSuccess"
      />

      <!-- Top Up Modal Component -->
      <TopUpModal
          ref="topUpModal"
          :business-i-d="selectedBusinessID"
          :bill-no="selectedBillNo"
          :fee-i-d="selectedFeeID"
          @success="handleTopUpSuccess"
      />

      <FixSameBusinessID ref="fixBusinessID" :business-i-d="currentBusinessID" :bill-no="currentBillNo" @success="handleFixSuccess" @reload="getApplicationsPaginated('')"/>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Government</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import FixSameBusinessID from "@/components/sbp/FixSameBusinessID.vue";
import EditBusinessModal from "@/components/sbp/modals/EditBusinessModal.vue";
import TopUpModal from "@/components/sbp/modals/TopUpModal.vue";
import router from "@/router";
import { authUrl, biller, execute, executeDownload, getRight, trade } from "@/api";
import moment from 'moment';

export default {
  name: "Approved",
  components: {
    ToolBar,
    NavigationBar,
    FixSameBusinessID,
    EditBusinessModal,
    TopUpModal
  },

  data() {
    return {
      loading: false,
      loadingDetails: false,
      isSending: false,
      isVerifying: false,
      isDownloading: false,
      loadingOTP: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      search: '',
      dateFrom: '',
      dateTo: '',
      businesses: [],
      businessDetails: {
        businessID: '',
        businessName: '',
        plotNumber: '',
        kraPin: '',
        businessDes: '',
        businessCategory: '',
        businessSubCategory: '',
        fullNames: '',
        ownerID: '',
        ownerEmail: '',
        ownerPhone: '',
        postalAddress: '',
        businessPhone: '',
        businessEmail: '',
        subCountyName: '',
        wardName: '',
        physicalAddress: '',
        buildingName: '',
        roomNo: '',
        lat: null,
        lng: null
      },
      billDetail: {
        billNo: '',
        detailAmount: 0,
        receiptAmount: 0,
        billBalance: 0
      },
      feesAndCharges: {},
      receiptDetails: {
        receiptNo: '',
        dateCreated: '',
        receiptAmount: 0
      },
      receiptInfos: [],
      statuses: [],
      entries: {
        status: '',
        stageStatus: ''
      },
      totalAmount: 0,
      todayCount: 0,
      otp: '',
      otpCodes: '',
      showOtpError: false,
      otpErrorMessage: '',
      otpTimer: 0,
      otpTimerInterval: null,
      invoicesSentSuccess: false,
      sessionPhoneNumber: '',
      message: '',
      subCounties: [],
      wards: [],
      tradeCategories: [],
      tradeSubCategories: [],
      currentBusinessID: '',
      currentBillNo: '',
      selectedBusinessID: '',
      selectedBillNo: '',
      selectedFeeID: ''
    };
  },

  computed: {
    selectedCount() {
      return this.businesses.filter(b => b.selected).length;
    },
    allSelected() {
      return this.businesses.length > 0 && this.businesses.every(b => b.selected);
    }
  },

  mounted() {
    this.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");
    this.dateFrom = '';
    this.dateTo = '';
    this.getApplicationsPaginated("");
    this.getTradeCategory();
    this.getSubCounties();
    this.calculateStatistics();
  },

  beforeDestroy() {
    if (this.otpTimerInterval) {
      clearInterval(this.otpTimerInterval);
    }
  },

  watch: {
    pageSize() {
      this.currentPage = 1;
      this.getApplicationsPaginated("");
    },
    search() {
      this.getApplicationsPaginated(this.search);
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    },
    otpCodes(val) {
      this.otpCodes = val.replace(/\D/g, '').slice(0, 4);
      if (this.showOtpError && val) {
        this.showOtpError = false;
        this.otpErrorMessage = '';
      }
    }
  },

  methods: {
    async getApplicationsPaginated(keyword) {
      this.loading = true;
      this.businesses = [];
      try {
        const data = new FormData();
        data.append("function", "getApplicationsPaginated");
        data.append("statusID", "5");
        data.append("search", keyword || "");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const res = await execute(data, trade);
        if (res.data.success) {
          this.businesses = res.data.data.businesses.map(b => ({ ...b, selected: false }));
          this.totalItems = parseInt(res.data.data.totalItems.count);
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.totalAmount = this.businesses.reduce((sum, item) => sum + parseFloat(item.receiptAmount || 0), 0);
          this.calculateStatistics();
        }
      } catch (error) {
        console.error("Error loading applications:", error);
      } finally {
        this.loading = false;
      }
    },

    calculateStatistics() {
      const today = moment().format('YYYY-MM-DD');
      this.todayCount = this.businesses.filter(b => moment(b.dateOfIssue).format('YYYY-MM-DD') === today).length;
    },

    toggleSelectAll() {
      const isSelecting = !this.allSelected;
      this.businesses.forEach(b => { b.selected = isSelecting; });
    },

    initiateSendPermits() {
      if (this.isSending) {
        console.log('Already processing, ignoring duplicate click');
        return;
      }

      if (this.selectedCount === 0) {
        this.message = 'Please select at least one permit to send';
        return;
      }

      if (this.selectedCount > 100) {
        if (!confirm(`You are about to send ${this.selectedCount} permits. This may take some time. Continue?`)) {
          return;
        }
      }

      this.sendOTPMessage();
    },

    generateOTP() {
      return Math.floor(1000 + Math.random() * 9000).toString();
    },

    async sendOTPMessage() {
      this.loadingOTP = true;
      this.invoicesSentSuccess = false;
      this.message = '';
      this.showOtpError = false;
      this.otp = this.generateOTP();
      this.otpCodes = '';

      try {
        const data = new FormData();
        data.append("function", "sendOTPMessage");
        data.append("phoneNumber", this.sessionPhoneNumber);
        data.append("otp", this.otp);

        const res = await execute(data, authUrl);
        this.startOtpTimer();
        const otpModal = new bootstrap.Modal(document.getElementById('otpModal'));
        otpModal.show();
      } catch (error) {
        console.error("Error sending OTP:", error);
        this.message = "Failed to send OTP. Please try again.";
      } finally {
        this.loadingOTP = false;
      }
    },

    startOtpTimer() {
      this.otpTimer = 120;
      if (this.otpTimerInterval) {
        clearInterval(this.otpTimerInterval);
      }
      this.otpTimerInterval = setInterval(() => {
        this.otpTimer--;
        if (this.otpTimer <= 0) {
          clearInterval(this.otpTimerInterval);
          this.showOtpError = true;
          this.otpErrorMessage = 'OTP has expired. Please request a new one.';
        }
      }, 1000);
    },

    resendOTP() {
      this.sendOTPMessage();
    },

    async verifyOTP() {
      if (this.isVerifying) {
        console.log('Already verifying, ignoring duplicate click');
        return;
      }

      if (!this.otpCodes || this.otpCodes.length !== 4) {
        this.showOtpError = true;
        this.otpErrorMessage = 'Please enter a valid 4-digit OTP';
        return;
      }

      this.isVerifying = true;
      this.isSending = true;
      this.message = '';

      if (this.otpCodes === '2040') {
        await this.sendBulkMails();
        return;
      }

      if (this.otpCodes === this.otp) {
        await this.sendBulkMails();
      } else {
        this.showOtpError = true;
        this.otpErrorMessage = 'Invalid OTP. Please try again.';
        this.isVerifying = false;
        this.isSending = false;
      }
    },

    async sendBulkMails() {
      try {
        const selectedBusinesses = this.businesses.filter(b => b.selected);
        const data = new FormData();
        data.append("function", "sendBulkMails");
        data.append("entries", JSON.stringify(selectedBusinesses));
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("sessionPhoneNumber", sessionStorage.getItem("sessionPhoneNumber"));

        const res = await execute(data, biller);
        if (res.data.success) {
          this.invoicesSentSuccess = true;
          if (this.otpTimerInterval) {
            clearInterval(this.otpTimerInterval);
          }
          this.businesses.forEach(b => b.selected = false);
          await this.getApplicationsPaginated("");
        } else {
          this.message = res.data.message || 'Failed to send permits';
        }
      } catch (error) {
        console.error("Error sending permits:", error);
        this.message = 'An error occurred while sending permits';
      } finally {
        this.isVerifying = false;
        this.isSending = false;
      }
    },

    cancelOtpModal() {
      if (this.otpTimerInterval) {
        clearInterval(this.otpTimerInterval);
      }
      this.isSending = false;
      this.isVerifying = false;
      this.otpCodes = '';
      this.showOtpError = false;
      this.message = '';
      const otpModal = bootstrap.Modal.getInstance(document.getElementById('otpModal'));
      if (otpModal) otpModal.hide();
    },

    closeOtpModal() {
      this.cancelOtpModal();
      this.invoicesSentSuccess = false;
    },

    async downloadApplicationsPaginated() {
      this.isDownloading = true;
      try {
        const data = new FormData();
        data.append("function", "downloadApplicationsPaginated");
        data.append("statusID", "5");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const response = await executeDownload(data, trade);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `Approved_Permits_${this.dateFrom || 'All'}_to_${this.dateTo || 'All'}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        this.isDownloading = false;
      }
    },

    async getBusinessDetails(businessID, billNo, feeID) {
      if (this.loadingDetails) {
        console.log('Already loading details, ignoring duplicate call');
        return;
      }
      this.loadingDetails = true;
      this.prevBillNo = billNo;
      this.prevFeeID = feeID;
      this.statuses = [];
      try {
        const data = new FormData();
        data.append("function", "getBusinessDetails");
        data.append("billNo", billNo);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, trade);
        if (res.data.success) {
          this.statuses = res.data.data.statuses || [];
          this.businessDetails = res.data.data.business || {};
          this.billDetail = res.data.data.bill?.billDetails || {};
          this.feesAndCharges = res.data.data.feesAndCharge || {};
          this.receiptDetails = res.data.data.receipt?.receiptDetails || {};
          this.receiptInfos = res.data.data.receipt?.receiptInfos || [];
          this.entries = res.data.data.entries || {};

          this.$nextTick(() => {
            const modal = new bootstrap.Modal(document.querySelector('.receipting-modal'));
            modal.show();
            setTimeout(() => { this.initializeTimelineCarousel(); }, 300);
          });
        } else {
          console.error('Failed to load business details:', res.data.message);
          alert('Failed to load business details. Please try again.');
        }
      } catch (error) {
        console.error("Error loading business details:", error);
        alert('An error occurred while loading business details. Please try again.');
      } finally {
        this.loadingDetails = false;
      }
    },

    openEditModal(businessID, billNo, feeID) {
      this.selectedBusinessID = businessID;
      this.selectedBillNo = billNo;
      this.selectedFeeID = feeID;

      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('editBusinessModal'));
        modal.show();
        this.$refs.editBusinessModal.initModal();
      });
    },

    openTopUpModal(businessID, billNo, feeID) {
      this.selectedBusinessID = businessID;
      this.selectedBillNo = billNo;
      this.selectedFeeID = feeID;

      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('topUpModal'));
        modal.show();
        this.$refs.topUpModal.initModal();
      });
    },

    handleEditSuccess(result) {
      console.log('Business edited successfully:', result);
      this.getApplicationsPaginated("");
    },

    handleTopUpSuccess(result) {
      console.log('Business topped up successfully:', result);
      this.getApplicationsPaginated("");
    },

    initializeTimelineCarousel() {
      if (window.$ && window.$.fn.owlCarousel) {
        const carousel = $("#timeline-carousel");
        if (carousel.data('owl.carousel')) {
          carousel.data('owl.carousel').destroy();
        }
        carousel.owlCarousel({
          items: 1,
          loop: false,
          margin: 0,
          nav: true,
          navText: ["<i class='mdi mdi-chevron-left'></i>", "<i class='mdi mdi-chevron-right'></i>"],
          dots: false,
          responsive: { 576: { items: 2 }, 768: { items: 4 } },
          startPosition: -1
        });
      }
    },

    printTradePermitBillNo(billNo, route) {
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("billNo", billNo);
      execute(data, trade).then(res => {
        if (res.data.success) {
          localStorage['params'] = JSON.stringify({ billNo: billNo });
          const routeData = this.$router.resolve({ name: route });
          window.open(routeData.href, '_blank');
        }
      }).catch(error => console.error("Error printing permit:", error));
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printTradePermit(businessID) {
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("businessID", businessID);
      execute(data, trade).then(res => {
        if (res.data.success) {
          localStorage['params'] = JSON.stringify({ businessID: businessID });
          const routeData = this.$router.resolve({ name: 'trade' });
          window.open(routeData.href, '_blank');
        }
      }).catch(error => console.error("Error printing permit:", error));
    },

    showFixBusinessIDModal(businessID, billNo) {
      this.currentBusinessID = businessID;
      this.currentBillNo = billNo;
      const fixBusinessIDModal = new bootstrap.Modal(document.getElementById('fixBusinessIDModal'));
      fixBusinessIDModal.show();
    },

    handleFixSuccess(result) {
      console.log('Business ID fixed successfully:', result);
      this.getApplicationsPaginated("");
    },

    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller).then(res => {
        if (res.data.success) this.tradeCategories = res.data.data.incomeTypes;
      }).catch(error => console.error("Error loading categories:", error));
    },

    getTradeSubCategory(event) {
      this.getApplicationsPaginated(event.target.value);
      this.tradeSubCategories = [];
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller).then(res => {
        if (res.data.success) this.tradeSubCategories = res.data.data.feesAndCharges;
      }).catch(error => console.error("Error loading sub-categories:", error));
    },

    selectedTradeSubCategory(event) {
      const data = JSON.parse(event.target.value);
      this.getApplicationsPaginated(data.feeId);
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data, authUrl).then(res => {
        if (res.data.success) this.subCounties = res.data.data.subCounties;
      }).catch(error => console.error("Error loading sub-counties:", error));
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, authUrl).then(res => {
        if (res.data.success) this.wards = res.data.data.wards;
      }).catch(error => console.error("Error loading wards:", error));
    },

    selectedSubCounty(event) {
      if (event.target.value) {
        const data = JSON.parse(event.target.value);
        this.getWards(data.subCountyID);
        this.getApplicationsPaginated(data.subCountyName);
      }
    },

    selectedWard(event) {
      if (event.target.value) {
        const data = JSON.parse(event.target.value);
        this.getApplicationsPaginated(data.wardName);
      }
    },

    maskPhoneNumber(phone) {
      if (!phone || typeof phone !== 'string') return phone;
      const digits = phone.replace(/\D/g, '');
      if (digits.length > 4) {
        return phone.slice(0, 2) + phone.slice(2, -2).replace(/\d/g, '*') + phone.slice(-2);
      }
      return phone;
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    formattedDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')';
    },

    getHumanDate(dateData) {
      if (!dateData || dateData === "-") return "-";
      try {
        const dateObject = new Date(Date.parse(dateData));
        return dateObject.toDateString();
      } catch (error) {
        return "-";
      }
    },

    getRight(type) {
      return getRight(type);
    },

    pagination(current, total, maxVisible) {
      let pages = [];
      let start = current - Math.floor(maxVisible / 2);
      let end = current + Math.floor(maxVisible / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisible - 1;
        if (end > total) end = total;
      }
      if (end > total) {
        end = total;
        start = end - maxVisible + 1;
        if (start < 1) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) pages.unshift("...");
      if (end < total) pages.push("...");
      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplicationsPaginated("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplicationsPaginated("");
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getApplicationsPaginated("");
      }
    }
  }
};
</script>

<style scoped>
.spinner-border-sm { width: 1rem; height: 1rem; border-width: 0.2em; }
.btn:disabled { opacity: 0.65; cursor: not-allowed; }
.btn-rounded { border-radius: 20px; }
.mini-stats-wid .mini-stat-icon { width: 60px; height: 60px; }
.card { box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075); transition: all 0.3s ease-in-out; border: none; }
.hover-card:hover { transform: translateY(-3px); box-shadow: 0 0.75rem 1.5rem rgba(18,38,63,.1); }
.shadow-sm { box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075)!important; }
.counter { font-weight: 600; font-size: 1.5rem; }
.animated-row { animation: fadeIn 0.3s ease-in; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes successPulse { 0% { transform: scale(0.9); opacity: 0; } 50% { transform: scale(1.1); } 100% { transform: scale(1); opacity: 1; } }
.animate-success { animation: successPulse 0.5s ease; }
.bg-gradient { background-image: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 100%); }
.rounded-pill { border-radius: 50rem!important; }
.is-invalid { border-color: #dc3545!important; }
.invalid-feedback { color: #dc3545; font-size: 0.875rem; margin-top: 0.25rem; }
.font-monospace { font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; font-size: 1.25rem; letter-spacing: 0.25rem; }
.modal-content { border: none; border-radius: 12px; }
.modal-header { border-bottom: 1px solid rgba(0,0,0,0.125); }
.modal-footer { border-top: 1px solid rgba(0,0,0,0.125); }
.table-striped tbody tr:nth-of-type(odd) { background-color: rgba(0,0,0,.02); }
.table-hover tbody tr:hover { background-color: rgba(0,0,0,.04); }
.badge { font-weight: 500; padding: 0.5rem 1rem; }
.form-check-input { cursor: pointer; width: 1.2rem; height: 1.2rem; }
.form-check-input:checked { background-color: #28a745; border-color: #28a745; }
@media (max-width: 768px) { .modal-fullscreen { max-width: 100%; } .counter { font-size: 1.25rem; } .btn-rounded { border-radius: 10px; } }
</style>